import { render } from "./search-index.vue?vue&type=template&id=4b4c53f2"
import script from "./search-index.vue?vue&type=script&lang=js"
export * from "./search-index.vue?vue&type=script&lang=js"

import "./search-index.vue?vue&type=style&index=0&id=4b4c53f2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__